import { atom } from "recoil";

export const guideState = atom<boolean>({
  key: "guideState",
  default: true,
});
